var _effectorFileName = "/builds/gmini/front-sm-api-sdk/src/ModelRepo/modelRepoConnect.ts";
import "core-js/modules/es.array.concat.js";
import { format } from 'url';
import { BimCategory, BimElement, BimFamily, BimModel, BimStandardSize } from '../BimEntity';
import { UserClassifier } from '../UserClassifierRepo';
import { BimFile } from './BimFile';
import { ModelRepoFolder } from './ModelRepoFolder';
import { ModelRepo } from './ModelRepo';
export function modelRepoConnect(models) {
  UserClassifier.getElementFromViewer.use(function (_ref) {
    var modelId = _ref.modelId,
        modelVersion = _ref.modelVersion,
        externalId = _ref.externalId;
    return models.get("/v1/model-repo/model/".concat(modelId, "/version/").concat(modelVersion, "/element?forge-external-id=").concat(externalId)).then(UserClassifier.getElementFromViewer.toPromise);
  });
  ModelRepo.fetch.use(function () {
    return models.get('/v1/model-repo').then(ModelRepo.fetch.toPromise);
  });
  ModelRepoFolder.Populated.fetchSilent.use(function (_ref2) {
    var folderId = _ref2.folderId;
    return models.get("/v1/model-repo/folder/".concat(folderId), {
      skip403: true
    }).then(ModelRepoFolder.Populated.fetchSilent.toPromise);
  });
  ModelRepoFolder.Populated.fetch.use(function (_ref3) {
    var folderId = _ref3.folderId;
    return models.get("/v1/model-repo/folder/".concat(folderId)).then(ModelRepoFolder.Populated.fetch.toPromise);
  });
  BimFile.Import.use(function (_ref4) {
    var bimFileUrn = _ref4.bimFileUrn,
        bimFileVersion = _ref4.bimFileVersion,
        projectUrn = _ref4.projectUrn;
    return models.post('/v1/model-repo/import', {
      urn: bimFileUrn,
      version: bimFileVersion,
      projectUrn: projectUrn
    }).then(BimFile.Import.toPromise);
  });
  BimModel.fetchLatestBimFile.use(function (_ref5) {
    var modelId = _ref5.modelId,
        projectUrn = _ref5.projectUrn;
    return models.get("/v1/model-repo/project/".concat(projectUrn, "/model/").concat(modelId, "/latest-bim-file")).then(BimModel.fetchLatestBimFile.toPromise);
  }); // BimModel

  BimModel.Populated.fetch.use(function (_ref6) {
    var urn = _ref6.urn,
        limit = _ref6.limit,
        offset = _ref6.offset,
        version = _ref6.version;
    return models.get(getModelUrl("/v1/model-repo/model/".concat(urn, "/version/").concat(version), limit, offset)).then(BimModel.Populated.fetch.toPromise);
  });
  BimModel.fetchViewerRefs.use(function (_ref7) {
    var modelId = _ref7.modelId,
        modelVersion = _ref7.modelVersion,
        id = _ref7.id,
        type = _ref7.type;
    return models.get(format({
      pathname: "/v1/model-repo/model/".concat(modelId, "/version/").concat(modelVersion, "/element-children-viewer-ref-data"),
      query: {
        id: id,
        type: type
      }
    })).then(BimModel.fetchViewerRefs.toPromise);
  }); // BimCategory

  BimCategory.Populated.fetch.use(function (_ref8) {
    var id = _ref8.id,
        limit = _ref8.limit,
        offset = _ref8.offset,
        modelVersion = _ref8.modelVersion,
        modelId = _ref8.modelId;
    return models.get(getModelUrl("/v1/model-repo/model/".concat(modelId, "/version/").concat(modelVersion, "/category/").concat(id), limit, offset)).then(BimCategory.Populated.fetch.toPromise);
  }); // BimFamily

  BimFamily.Populated.fetch.use(function (_ref9) {
    var id = _ref9.id,
        limit = _ref9.limit,
        offset = _ref9.offset,
        modelVersion = _ref9.modelVersion,
        modelId = _ref9.modelId;
    return models.get(getModelUrl("/v1/model-repo/model/".concat(modelId, "/version/").concat(modelVersion, "/family/").concat(id), limit, offset)).then(BimFamily.Populated.fetch.toPromise);
  }); // BimStandardSize

  BimStandardSize.Populated.fetch.use(function (_ref10) {
    var id = _ref10.id,
        limit = _ref10.limit,
        offset = _ref10.offset,
        modelVersion = _ref10.modelVersion,
        modelId = _ref10.modelId;
    return models.get(getModelUrl("/v1/model-repo/model/".concat(modelId, "/version/").concat(modelVersion, "/standard-size/").concat(id), limit, offset)).then(BimStandardSize.Populated.fetch.toPromise);
  }); // BimElement

  BimElement.fetch.use(function (_ref11) {
    var id = _ref11.id,
        limit = _ref11.limit,
        offset = _ref11.offset,
        modelVersion = _ref11.modelVersion,
        modelId = _ref11.modelId;
    return models.get(getModelUrl("/v1/model-repo/model/".concat(modelId, "/version/").concat(modelVersion, "/element/").concat(id), limit, offset)).then(BimElement.fetch.toPromise);
  });
  BimElement.fetchByIds.use(function (_ref12) {
    var modelVersion = _ref12.modelVersion,
        modelId = _ref12.modelId,
        elementIds = _ref12.elementIds;
    return models.post("/v1/model-repo/model/".concat(modelId, "/version/").concat(modelVersion, "/elements"), {
      elementIds: elementIds
    }).then(BimElement.fetchByIds.toPromise);
  });

  var getModelUrl = function getModelUrl(pathname, limit, offset) {
    return format({
      pathname: pathname,
      query: {
        limit: limit,
        offset: offset
      }
    });
  };
}